import { createSha256Base64 } from '../utils/createSha256Base64'

type CreatePrivateGetHeadersParameters = {
  readonly apiKey: string
  readonly apiSecret: string
  readonly passphrase: string
  readonly urlPath: string
  readonly query: string
}

export const createPrivateGetHeaders = async ({
  apiKey,
  apiSecret,
  passphrase,
  urlPath,
  query,
}: CreatePrivateGetHeadersParameters): Promise<HeadersInit> => {
  const timestamp = Date.now().toString()
  const data = `${timestamp}GET${urlPath}${query.length > 0 ? '?' : ''}${query}`
  const signature = await createSha256Base64(data, apiSecret)
  const passphraseBase64 = await createSha256Base64(passphrase, apiSecret)
  return {
    'KC-API-KEY': apiKey,
    'KC-API-SIGN': signature,
    'KC-API-TIMESTAMP': timestamp,
    'KC-API-PASSPHRASE': passphraseBase64,
    'KC-API-KEY-VERSION': '3',
  }
}
